import React from "react";

import Box from "../Box";

const Special3 = props => {
  return (
    <section className="hp__block hp__block--special  hp__block--special--3 container-fluid">
      <div className="row">
        <Box
          {...props}
          id="b1"
          type="pile"
          settings={props.settings.b1}
          classes="hp__box--main col-xs-12 col-sm-6"
          thumbnailHeight="825"
        />

        <div className="hp__box--column hp__box--column--special-one col-xs-6 col-sm-3">
          <ul className="no-padding list-unstyled">
            <li className="hp__box--small hp__box--small--first col-xs-12 col-sm-12">
              <Box
                {...props}
                id="b2"
                type="pile"
                settings={props.settings.b2}
                classes="col-xs-12 no-margin-padding hp__box--small__content"
              />
            </li>
            <li className="hp__box--small hp__box--small--second col-xs-12 col-sm-12">
              <Box
                {...props}
                id="b3"
                type="pile"
                settings={props.settings.b3}
                classes="col-xs-12 no-margin-padding hp__box--small__content"
              />
            </li>
            <li className="hp__box--small hp__box--small--third col-xs-12 col-sm-12">
              <Box
                {...props}
                id="b4"
                type="pile"
                settings={props.settings.b4}
                classes="col-xs-12 no-margin-padding hp__box--small__content"
              />
            </li>
          </ul>
        </div>

        <div className="hp__box--column hp__box--column--special-two col-xs-6 col-sm-3">
          <ul className="no-padding list-unstyled">
            <li className="hp__box--small hp__box--small--first col-xs-12 col-sm-12">
              <Box
                {...props}
                id="b5"
                type="pile"
                settings={props.settings.b5}
                classes="col-xs-12 no-margin-padding hp__box--small__content"
              />
            </li>
            <li className="hp__box--small hp__box--small--second col-xs-12 col-sm-12">
              <Box
                {...props}
                id="b6"
                type="pile"
                settings={props.settings.b6}
                classes="col-xs-12 no-margin-padding hp__box--small__content"
              />
            </li>
            <li className="hp__box--small hp__box--small--third text-logo col-xs-12 col-sm-12 ">
              <Box
                {...props}
                id="b7"
                type="partner"
                settings={props.settings.b7}
                classes="col-xs-12 no-margin-padding hp__box--small__content old-centered"
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Special3;
